import { MenuLink, toMenuLinks } from "./normalize";
import MENU_QUERY from "../graphql/MenuQuery.graphql";

export async function safeQuery(apolloClient: any, query: any, variables?: Record<string, any>): Promise<any | null> {
	if (!apolloClient) return null;
	try {
		const result = await apolloClient.query({ query, variables: variables || {}, fetchPolicy: "no-cache" });
		return result?.data || null;
	} catch (e) {
		debug('safeQuery', e);
		return null;
	}
}

export async function fetchMenu(apolloClient: any, name: string): Promise<MenuLink[]> {
	const data = await safeQuery(apolloClient, MENU_QUERY, { name });
	return toMenuLinks(data?.menu);
}

export async function fetchList(
	apolloClient: any,
	query: any,
	{ page, pageSize, filter }: { page: number; pageSize: number; filter?: any }
): Promise<{ edges: any[]; total: number }> {
	const data = await safeQuery(apolloClient, query, { page, pageSize, orderBy: "CHANGED", direction: "DESC", filter: filter ?? null });
	return { edges: data?.res?.edges || [], total: Number(data?.res?.count) || 0 };
}
